import { useNavigate } from 'react-router-dom';

/* Utils */
import { getCountryImage } from '../../../utils/countryUtils';

/* CSS */
import styles from "./style/statDetails.module.css";

/* Icons */
import first_place from '../../../assets/icons/first_place.png';
import second_place from '../../../assets/icons/second_place.png';
import third_place from '../../../assets/icons/third_place.png';

const placeIcons = [first_place, second_place, third_place];

const CountriesDetail = ({ countries }) => {

    const navigate = useNavigate();

    if (!countries || countries.length === 0) {
        return (
            <div className={styles.empty}>
                No countries visited yet
            </div>
        )
    }

    return (
        <div className={styles.list}>
            {countries.map((c, index) => {
                const placeIcon = placeIcons[index];   // undefined for 4th place onward

                return (
                    <div key={c.country} className={styles.countryRow}>
                        {placeIcon && (
                            <img
                                src={placeIcon}
                                className={styles.placeIcon}
                                alt={`Rank ${index + 1}`}
                                style={index === 0 ? { top: '-4px' } : { top: '-16px' }}
                            />
                        )}

                        {/* Header: country image + name + visit count */}
                        <div className={styles.countryHeader}>
                            <img
                                className={styles.avatar}
                                src={getCountryImage(c.country)}
                                alt={c.country}
                                loading='lazy'
                            />
                            <div className={styles.rowMain}>
                                <div className={styles.rowTitle}>{c.country}</div>
                                <div className={styles.rowSub}>
                                    {`${c.count} ${c.count === 1 ? 'visit' : 'visits'}`}
                                </div>
                            </div>
                        </div>

                        {/* Trip chips */}
                        <div className={styles.countryTrips}>
                            {c.trips.map((trip) => (
                                <button
                                    key={trip.id}
                                    type="button"
                                    className={styles.tripChip}
                                    onClick={() => navigate(`/trip/${trip.id}`)}
                                >
                                    {trip.title}
                                </button>
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default CountriesDetail;
